import { prefeituraService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const prefeituraAction = {
    getPrefeitura,
    getPrefeituraById,
    onChangeProps,
    editPrefeituraInfo,
    createPrefeitura,
    deletePrefeituraById,
    getPrefeiturasSelect,
    getPrefeiturasSelectById,
    clear
};
function getPrefeitura(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'prefeituras';
        prefeituraService.get(apiEndpoint)
            .then((response) => {
              //  response.data.unshift({ id: '0', nome: ' SELECIONE ...' });
                dispatch(changePrefeiturasList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createPrefeitura(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'prefeituras/';
        prefeituraService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/prefeituras');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function getPrefeituraById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'prefeituras/' + id;
        prefeituraService.get(apiEndpoint)
            .then((response) => {
                dispatch(editPrefeiturasDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

function editPrefeituraInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'prefeitura/' + id;
        prefeituraService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/prefeituras');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function deletePrefeituraById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {

                    let apiEndpoint = 'prefeituras/' + id;
                    prefeituraService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deletePrefeiturasDetails());
                                dispatch(prefeituraAction.getPrefeitura());
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })

                }
            });


    };
}

function getPrefeiturasSelect() {  //pega o select que utiliza a inscrição estadual no lugar do Id da prefeitura
    return dispatch => {
        let apiEndpoint = 'prefeituras/select';
        prefeituraService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '', Text: 'SELECIONE ...' });
                dispatch(changePrefeiturasList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}

function getPrefeiturasSelectById() {  //pega o select que usa o Id da prefeitura 
    return dispatch => {
        let apiEndpoint = 'prefeituras/selectId';
        prefeituraService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '0', Text: 'SELECIONE ...' });
                dispatch(changePrefeiturasList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}
export function changePrefeiturasList(prefeitura) {
    return {
        type: "FETECHED_ALL_PREFEITURA",
        prefeitura: prefeitura
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editPrefeiturasDetails(prefeitura) {
    return {
        type: "PREFEITURA_DETAIL",
        id: prefeitura.id,
        nome: prefeitura.nome,
        inscricao_estadual: prefeitura.inscricao_estadual,
        data_cadastro: prefeitura.data_cadastro,
        usuario_cadastro: prefeitura.usuario_cadastro,
        data_exclusao: prefeitura.data_exclusao,
        usuario_exclusao: prefeitura.usuario_exclusao

    }
}
export function updatedUserInfo() {
    return {
        type: "PREFEITURA_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "PREFEITURA_CREATED_SUCCESSFULLY"
    }
}
export function deletePrefeiturasDetails() {
    return {
        type: "DELETED_PREFEITURA_DETAILS"
    }
}

export function clear() {
    return {
        type: "PREFEITURA_CLEAR"
    };
}